import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { goToUrl } from '../../utils'
import { Button, Table } from '..'

import { IconEditSvg, PlusSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

import { fetchAllTests } from '../../../main/usecases/admin-menu/tests'
import {
  allTestsModel,
  testContentModel
} from '../../../domain/models/admin-models'
import { useAlert } from 'react-alert'

const NewTest = () => {
  const [page, setPage] = useState(1)
  const history = useHistory()
  const [tests, setTests] = useState<allTestsModel>()
  const alert = useAlert()
  const columns = useMemo(
    () => [
      {
        Header: 'Código',
        accessor: 'nameToCódigo'
      },
      {
        Header: 'Nome',
        accessor: 'nameToNome'
      },
      {
        Header: 'Nome Satepsi',
        accessor: 'nameToSatepsi'
      },
      {
        Header: 'Ativo',
        accessor: 'active'
      },
      {
        Header: '',
        accessor: 'actions'
      }
    ],
    []
  )
  useEffect(() => {
    ;(async () => {
      const tests = await fetchAllTests(page).load()
      setTests(tests)
    })()
  }, [page])
  const data = useMemo(() => {
    const handleRedirectToRegistrationData = async (
      teste: testContentModel
    ) => {
      try {
        goToUrl(history, `/novo-teste`, {
          aplicacao: teste.aplicacao,
          ativo: teste.ativo,
          autores: teste.autores,
          bibliografia: teste.bibliografia,
          cdTeste: teste.cdTeste,
          correcao: teste.correcao,
          dataAprovacao: teste.dataAprovacao,
          editora: teste.editora,
          idadeMaxima: teste.idadeMaxima,
          idadeMinima: teste.idadeMinima,
          informacoesAdicionais: teste.informacoesAdicionais,
          nome: teste.nome,
          nomeSatepsi: teste.nomeSatepsi,
          prazoEstudosNormatizacao: teste.prazoEstudosNormatizacao,
          prazoEstudosValidade: teste.prazoEstudosValidade
        })
      } catch (error) {
        console.error(error)
        alert.show('Erro ao entrar em um teste', {
          type: 'error',
          timeout: 4000
        })
      }
    }

    return tests?.content?.map((item) => {
      return {
        nameToCódigo: item?.cdTeste,
        nameToNome: item?.nome,
        nameToSatepsi: item?.nomeSatepsi,
        active: item?.ativo === true ? 'sim' : 'não',
        actions: (
          <div className="table-icons">
            <button
              onClick={() => handleRedirectToRegistrationData(item)}
              title="Editar"
            >
              <IconEditSvg />
            </button>
          </div>
        )
      }
    })
  }, [alert, history, tests?.content])
  return (
    <S.Wrapper>
      <S.Title>Testes</S.Title>
      <S.Body>
        <Button
          initialIcon={<PlusSvg />}
          onClick={() => goToUrl(history, '/novo-teste')}
        >
          Novo cadastro
        </Button>
        <S.TableContainer>
          <Table
            onClick={() => ({})}
            columns={columns}
            dataTable={data || []}
            handlePageClick={(currentPage: any) =>
              setPage(currentPage.selected + 1)
            }
            pageCount={tests?.totalPages}
          />
        </S.TableContainer>
      </S.Body>
    </S.Wrapper>
  )
}
export default NewTest
